import React from 'react';
import { connect } from 'react-redux';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';
import { showDatasourceSettings } from '../actions';

const DatasourceAction = ({
  code,
  name,
  disabled,
  datasourceSettings,
}) => (
  <RibbonMenu
    name="datasource"
    icon="server"
    message="actions.datasource"
    className="aridhia-dataset-datasource-settings-action"
    onClick={() => datasourceSettings('open', code, name)}
    disabled={disabled}
  />
);

const mapDispatchToProps = {
  datasourceSettings: showDatasourceSettings,
};

export default connect(null, mapDispatchToProps)(DatasourceAction);
